export default {"src":"/_next/static/media/redit.a3e454db.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};